import { SIcon } from '@avalara/skylab-sdk/react';

import { getValidationMessage } from '../helpers/contact-info';

import type { BillingContactField, ValidationError } from '@avalara/types/billingContact';

type Props = {
  fieldName: BillingContactField;
  fieldValue: string | null;
  disabled: boolean;
  displayName: string;
  showValidationErrors: boolean;
  validationError: ValidationError;
  validationName?: string;
  placeholder?: string;
  required: boolean;
  onUpdateFormField: (_: BillingContactField, __: string) => void;
};

const ContactInfoField = ({
  fieldName,
  fieldValue,
  disabled,
  displayName,
  showValidationErrors,
  validationError,
  validationName,
  placeholder,
  required,
  onUpdateFormField,
}: Props) => {
  const validationText = validationName || displayName.toLowerCase();
  const validationMsg = getValidationMessage(validationError, fieldName, validationText);

  const showError = showValidationErrors && validationMsg != null;

  const inputId = `contact-info-field-${fieldName.toLowerCase()}`;
  const messageId = `${inputId}-message`;

  return (
    <>
      <label className={required ? 'required' : ''} htmlFor={inputId}>
        {displayName}
      </label>

      <input
        id={inputId}
        className={`fs-mask ${showError ? 'error' : ''}`}
        data-ref={`buydot.contact-info.${fieldName.toLowerCase()}.input`}
        disabled={disabled}
        aria-invalid={showError ? 'true' : 'false'}
        aria-describedby={showError ? messageId : undefined}
        aria-required={required ? 'true' : 'false'}
        aria-label={inputId}
        type='text'
        value={fieldValue || ''}
        onChange={(e) => onUpdateFormField(fieldName, e.target.value)}
        placeholder={placeholder || ''}
      />

      <div id={messageId} data-ref='buydot.contact-info.validation-message' className='input-msg'>
        <SIcon name='alert-circle-filled' aria-hidden='true' />
        {validationMsg}
      </div>
    </>
  );
};

export default ContactInfoField;
